"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.regexp.flags");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var react_1 = __importDefault(require("react"));

var theme_1 = require("../../../styles/theme");

var TextBody_1 = __importDefault(require("../../base/TextBody"));

var FooterWrapper = styled_1["default"]('footer')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 100%;\n  padding: ", "px;\n  ", "\n"], ["\n  max-width: 100%;\n  padding: ", "px;\n  ", "\n"])), theme_1.theme.spacing.standard * 2, function (props) {
  return props.dark && "background: linear-gradient(0deg, #064650 0%, #105059 37.82%, #579597 100%);\n    color: #fff;\n    div.border-top {\n      border-top: 0.5px solid #6a9096;\n      " + theme_1.theme.breakpoints.tabletDown + " {\n      }\n    }";
});
var TextLink = styled_1["default"]('a')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  &:hover {\n    color: ", ";\n  }\n"])), function (props) {
  return props.dark ? theme_1.theme.colors.White : theme_1.theme.lightLinkColor;
}, function (props) {
  return props.dark ? theme_1.theme.colors.White : theme_1.theme.lightLinkHoverColor;
});
var FooterMenu = styled_1["default"]('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: ", "px 0;\n  .footerMenu-link {\n    margin-right: ", "px;\n  }\n"], ["\n  margin: ", "px 0;\n  .footerMenu-link {\n    margin-right: ", "px;\n  }\n"])), theme_1.theme.spacing.small * 2, theme_1.theme.spacing.standard);

var Footer = function Footer(props) {
  var flags = props.flags || ['links', 'terms', 'address'];
  var disclosures = {
    address: react_1["default"].createElement(TextBody_1["default"], {
      xsmall: true,
      secondary: true,
      dark: props.dark
    }, react_1["default"].createElement("p", null, "Investments & Insurance Products: Not FDIC Insured \u2022 No Bank Guarantee \u2022 May Lose Value"), react_1["default"].createElement("address", {
      style: {
        fontStyle: 'normal'
      }
    }, "Kindur 147 W 24th Street, 6th Floor", react_1["default"].createElement("br", null), "New York, NY 10011", react_1["default"].createElement("br", null), "Email:", ' ', react_1["default"].createElement(TextLink, {
      dark: props.dark,
      title: "support@kindur.com",
      href: "mailto:support@kindur.com"
    }, "support@kindur.com")), react_1["default"].createElement("p", null, "Tel:", ' ', react_1["default"].createElement(TextLink, {
      dark: props.dark,
      title: "(800) 961-3572",
      href: "tel:8009613572"
    }, "(800) 961-3572")), react_1["default"].createElement("p", null, "\xA9 Copyright ", new Date().getFullYear(), " Kindur Services Inc.")),
    guaranteed: react_1["default"].createElement(TextBody_1["default"], {
      xsmall: true,
      secondary: true,
      dark: props.dark
    }, "References to \u201Cguaranteed income,\u201D \u201Cincome for life,\u201D or \u201Clifetime income\u201D refer to income paid by a fixed annuity contract offered by Kindur Insurance Services LLC."),
    links: react_1["default"].createElement(FooterMenu, null, react_1["default"].createElement(TextLink, {
      dark: props.dark,
      className: 'footerMenu-link',
      href: 'https://app.kindur.com/legal/'
    }, "Legal"), react_1["default"].createElement(TextLink, {
      dark: props.dark,
      className: 'footerMenu-link',
      href: 'https://app.kindur.com/Producer_Licenses.pdf',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, "Licenses")),
    insurance: react_1["default"].createElement(TextBody_1["default"], {
      xsmall: true,
      secondary: true,
      dark: props.dark
    }, "Fixed annuities are offered by Kindur Insurance Services LLC and are issued by American Equity Investment Life Insurance Company, an unaffiliated insurance company. Detailed information can be found in the fixed annuity contract itself and other materials that may be delivered in connection with any application for or purchase of a contract. Review important additional information about our insurance services", ' ', react_1["default"].createElement(TextLink, {
      dark: props.dark,
      href: 'https://app.kindur.com/disclosures',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, "here"), ' ', "."),
    investment: react_1["default"].createElement(TextBody_1["default"], {
      xsmall: true,
      secondary: true,
      dark: props.dark
    }, "Investment advisory services are provided by Kindur Investment Services LLC, an SEC registered investment advisor. Investing involves risk. Past performance is not a guarantee or indicative of future returns. The value of your investment will fluctuate, and you may gain or lose money. Nothing on this website is an offer to buy or sell any security or an offer or solicitation in any jurisdiction where we are not authorized to do business. All charts, figures, and graphs are for illustrative purposes only and may not reflect actual performance. Review important additional information about our advisory services", ' ', react_1["default"].createElement(TextLink, {
      dark: props.dark,
      href: 'https://app.kindur.com/disclosures',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, "here"), ' ', "."),
    terms: react_1["default"].createElement(TextBody_1["default"], {
      xsmall: true,
      secondary: true,
      dark: props.dark
    }, "This website is operated and maintained by Kindur Services Inc. (together with its subsidiaries and affiliates, \u201CKindur\u201D). By using this website, you accept our", ' ', react_1["default"].createElement(TextLink, {
      dark: props.dark,
      href: 'https://app.kindur.com/Kindur_Terms_of_Use.pdf',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, "Terms of Use"), ' ', "and", ' ', react_1["default"].createElement(TextLink, {
      dark: props.dark,
      href: 'https://kindur.com/privacy-policy',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, "Privacy Policy"), "."),
    resource: react_1["default"].createElement(TextBody_1["default"], {
      xsmall: true,
      secondary: true,
      dark: props.dark
    }, react_1["default"].createElement(TextLink, {
      dark: props.dark,
      href: 'https://app.kindur.com/disclosures',
      target: '_blank',
      rel: 'noopener noreferrer'
    }, "Important information & disclosures about Kindur\u2019s Resource Center")),
    smartdraw: react_1["default"].createElement(TextBody_1["default"], {
      xsmall: true,
      secondary: true,
      dark: props.dark
    }, "*Estimated increase based on projected difference between the most efficient and least efficient withdrawal strategy for a 62 year old married couple from Florida with $1 million in assets split equally between IRA, Roth and taxable accounts. User and user\u2019s spouse were assumed to have a salary while working of $80,000 and $30,000 respectively and both retired and started taking Social Security at age 62. A retirement replacement ratio was utilized to provide an estimate of post-retirement spending based on pre-retirement income. To learn more about SmartDraw's personalized withdrawal strategies and the assumptions that make them work, please", ' ', react_1["default"].createElement(TextLink, {
      dark: props.dark,
      title: 'SmartDraw methodology',
      href: 'https://app.kindur.com/smartdraw-methodology',
      target: '_blank'
    }, "click here"), ".")
  };
  return react_1["default"].createElement(FooterWrapper, {
    dark: props.dark
  }, props.children, flags.map(function (flag) {
    return disclosures[flag];
  }));
};

exports["default"] = Footer;
var templateObject_1, templateObject_2, templateObject_3;